import PagesWrapper from "../mainpage/PagesWrapper";
import styles from "./Ausstellung.module.css";
import { img0 } from "../../../media/ausstellung/export";
import useWindowDimensions from "../../util/useWindowDimensions";
import { useScrollbarWidth } from "../../util/useScrollbarWidth";
import { Section } from "../../../types";
import { useState } from "react";
import Modal from "../../util/Modal";
import Gallery from "../../section/ImageGallery";

const Ausstellung = ({
  data,
  bgData,
}: {
  data: Section[];
  bgData: Section[];
}) => {
  return (
    <PagesWrapper
      data={bgData}
      header={"AUSSTELLUNGEN <br> PREISE"}
      header2={"Lightsart / Photography / Graphics / PhotoGraphics"}
      image={img0}
    >
      {data.map((v, i) => (
        <AusstellungSection
          images={v.pictures.map((p) => p.dataUrl)}
          text={v.texts[0].content}
          key={i}
        />
      ))}
    </PagesWrapper>
  );
};

const AusstellungSection = ({
  images,
  text,
}: {
  images: string[];
  text: string;
}) => {
  const { width } = useWindowDimensions();
  const scrollbarWidth = useScrollbarWidth();
  const imageWidth = (width - scrollbarWidth) / 10;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.imageSection}>
      <div className={styles.imageSectionText}>{text}</div>
      <div className={styles.imageSectionImage}>
        {images.map((img, index) => (
          <>
            <img
              width={imageWidth}
              style={{
                cursor: "pointer",
              }}
              key={index}
              src={img}
              alt={"img"}
              onClick={() => setIsOpen(true)}
            />
            {isOpen && (
              <Modal onClose={() => setIsOpen(false)}>
                <Gallery
                  images={images}
                  closeGallery={() => setIsOpen(false)}
                />
              </Modal>
            )}
          </>
        ))}
      </div>
    </div>
  );
};

export default Ausstellung;
